
export type UnauthorizedErrorResponse = {
  error?: string;
};
